<template>
	<span
		class="truncated-number"
		:class="{ 'truncated-number--clickable': truncated }"
		:title="truncated ? (expanded ? 'کلیک بۆ کورتکردنەوە' : full) : undefined"
		@click.stop="onClick"
	>{{ shown }}{{ suffix }}</span>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { truncateDisplayNumber } from '../utils/displayNumber.js'

const props = defineProps({
	value: { type: [Number, String], default: 0 },
	decimals: { type: Number, default: 3 },
	suffix: { type: String, default: '' },
})

const expanded = ref(false)

const info = computed(() => truncateDisplayNumber(props.value, props.decimals))
const truncated = computed(() => info.value.truncated)
const full = computed(() => info.value.full)
const shown = computed(() => (expanded.value ? info.value.full : info.value.short))

watch(() => props.value, () => {
	expanded.value = false
})

function onClick() {
	if (!truncated.value) return
	expanded.value = !expanded.value
}
</script>

<style scoped>
.truncated-number--clickable {
	cursor: pointer;
	border-bottom: 1px dotted currentColor;
	user-select: none;
}
</style>
